import React from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types';


export function UiScrollNavWr(props) {
    
    return (
        <>
             <ul className='sb-scroll-to-nav-wr'>
                    {props.children}
             </ul>
        </>
    )
}
export function UiScrollNavItem(props) {
    const location = useLocation();
    
    return (
        <>
          <li>
            <a href={'#' + props.hash} 
            className={location.hash == '#' + props.hash ? 'scroll-to-element-active' : ''}>{props.hashText}</a>
          </li>  
        </>
    )
}

export function UiScrollNavLinkItem(props) {
  return (
      <>
        <li>
          <span className="sb-external-link-cls" onClick={props.onClick}>{props.externalLink}</span>
        </li>  
      </>
  )
}

UiScrollNavItem.propTypes = {
  hash: PropTypes.string
};




  